















import { Vue, Component } from "vue-property-decorator";
import { User } from "@/modules/auth/types";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({})
export default class Congratulations extends Vue {
  @Auth.Getter("getUser") user!: User;

  created() {
    this.$mixpanel.track("Account Activation Completed", {
      ...this.user,
    });
  }
}
